import { pathOr } from 'ramda';

import { IState } from '../../store';

export const getNewbuildingAdvantages = (state: IState) => {
  return pathOr([], ['offerData', 'newObject', 'advantages'], state);
};
